import { api } from "@/lib/axios";

import { User } from "@/types/user";

const resetPassword = (token: string, password: string): Promise<User> =>
  api
    .post(`/auth/reset-password`, { token, password })
    .catch(() => ({})) as Promise<User>;

export default resetPassword;
